import {Pipe, PipeTransform} from '@angular/core';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import {firestoreDateToJsDate} from '../utils/utils';



@Pipe({
    name: 'timestamp'
})
export class TimestampPipe implements PipeTransform {

    transform(value: firebase.firestore.Timestamp | Date): Date {
        if (!value) return null;
        return firestoreDateToJsDate(value);
    }


}